import { Model } from '@app/models/model';
import { CONSTANTS } from '@app/shared/constants';
import { COLOR_CONSTANTS } from '@app/shared/scss-variables.generated';

const COLORS = {
    RED: COLOR_CONSTANTS['$red-clay'],
    ORANGE: COLOR_CONSTANTS['$sunset'],
    GREEN: COLOR_CONSTANTS['$cut-grass'],
};

export class Budget extends Model {
    static types = CONSTANTS.budgetTypes;

    id: number;
    name: string;
    type: string;
    value: number;
    thresholds: number[];
    actual: number;

    get hexColor() {
        const perc = (this.actual * 100) / this.value;
        return perc >= 91 ? COLORS.RED : perc <= 50 ? COLORS.GREEN : COLORS.ORANGE;
    }

    get percentages() {
        return (this.thresholds || []).map((thresh) => Math.round((thresh / this.value) * 100));
    }
    set percentages(values: number[]) {
        this.thresholds = (values || []).map((val) => Math.round((val * this.value) / 100));
    }
}
